import API from "../../../store/api";
import { authLogout } from "../../../store/actions/authActions";
import { setCurrentApplication, clearCurrentApplication } from "../../../store/actions/applicationActions";
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { getApplications } from "./getApplications";
import { setNotifications } from "../../../store/actions/notificationActions";

export const deleteApplication = (id, bearerAuth, formFunction) => {
  return async dispatch => {
    API.delete(`/api/portal/application/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status < 500)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getApplications(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully deleted.'
          }))
          formFunction();
        } else if (response.status === 401) {
          dispatch(clearCurrentApplication);
          dispatch(authLogout);
        } else {
          dispatch(clearCurrentApplication)
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          } 
        }
        dispatch(setMessage({
          title: 'Application Retrieval Failed',
          message: message,
          type: 'ERR',
        }))
        dispatch(clearCurrentApplication);
      })
  }
}